<div class="confirm-assign-rule evir-font-default" cdkTrapFocus cdkTrapFocusAutoCapture>
    <h3 class="heading-3">{{ "assigned rule" | i18next: { format: "capitalize" } }}</h3>
    <p>{{ "select from existing rules" | i18next: { format: "capitalize" } }}</p>
    <app-rule-filter
        [companyId]="data"
        (ruleIds)="getRuleId($event)"
        [isMultiSelect]="false"
        context="rule-filter assign-rule"
        cdkFocusInitial
    ></app-rule-filter>
    <div
        mat-dialog-actions
        align="center"
    >
        <app-action-button
            title="cancel"
            type="outlined-1"
            (buttonClicked)="cancelClick()"
        ></app-action-button>
        <app-action-button
            title="save"
            (buttonClicked)="confirmAssignRule()"
        ></app-action-button>
    </div>
</div>
